export const searchByString = (pattern, string) => {
    let patternArray = pattern.split(" ");
    let searchArray = string.split(" ");
    let searchCounter = 0;
    patternArray.forEach(patternElement => {
        if(patternElement) {
            searchArray.forEach(searchString => {
                if (searchString && patternElement.search(new RegExp(searchString, "i")) === 0) {
                    searchCounter++;
                }
            })
        }
    })
    return searchCounter;
}